<template>
  <component
    :is="e3LibComponent"
    :asset="asset"
    :asset-type="assetType"
    :asset-module="assetModule"
    :asset-general-info="assetGeneralInfo"
    :notifications="notifications"
  />
</template>

<script>
import GeneralDataService from '@/domain/services/installation/assetInfo/generalData';
import ResourceService from '@/domain/services/resource';
import moduleSubtypeComponents from '@/domain/data/installation/engineering/moduleSubtypeComponents';

export default {
  name: 'Modules',
  props: {
    asset: Object,
    assetType: Object,
    assetModule: Object,
  },
  data: () => ({
    assetGeneralInfo: {},
    notifications: [],
  }),
  computed: {
    e3LibComponent() {
      const { subtype } = this.assetModule || {};
      return moduleSubtypeComponents[subtype];
    },
  },
  async mounted() {
    await this.getAssetInfos();
    await this.getNotifications();
  },
  methods: {
    async getAssetInfos() {
      const { assetId } = this.$route.params;
      if (!assetId || !this.assetType) return;
      this.assetGeneralInfo = await GeneralDataService.getAssetInfosByAssetType(
        this.assetType.id,
        assetId,
      );
    },
    async getNotifications() {
      const { assetModuleId } = this.$route.params;
      this.notifications = await ResourceService.getNotificationsByResourceId(
        assetModuleId,
      );
    },
  },
};
</script>
